import React, { FunctionComponent } from 'react';

import {
  PolicyIssued,
  SingleSegmentedControlStepProps,
} from 'scenes/common/types';
import { SegmentedControlOptions } from 'scenes/common/components/Questions';
import SingleSegmentedControlStep from 'scenes/common/components/Steps/SingleSegmentedControlStep';

export const STATE_KEY = 'policyIssued';
export const QUESTION =
  'Do you want the policy issued in the name of a person or a business?';

export const OPTIONS: SegmentedControlOptions<PolicyIssued, PolicyIssued> = [
  { label: PolicyIssued.Person, value: PolicyIssued.Person },
  { label: PolicyIssued.Business, value: PolicyIssued.Business },
];

const PersonalOrBusinessPolicyStep: FunctionComponent<Pick<
  SingleSegmentedControlStepProps<PolicyIssued, PolicyIssued>,
  'defaultStateValue' | 'onNext'
>> = ({ defaultStateValue, onNext }) => (
  <SingleSegmentedControlStep
    onNext={onNext}
    question={QUESTION}
    stateKey={STATE_KEY}
    options={OPTIONS}
    defaultStateValue={defaultStateValue}
    validationRules={{
      validate: {
        oneOf: (value) => OPTIONS.some((option) => option.value === value),
      },
    }}
  />
);

export default PersonalOrBusinessPolicyStep;
